module.exports = __webpack_public_path__ + "img/e8c15c1.jpg";